// frontend/src/components/Default/Default.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Default.css';

const Default = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleBackToHome = () => {
        navigate('/');
    };

    return (
        <div className="default-page">
            <div className="content-wrapper">
                <div className="icon-container">
                    <span className="construction-icon">🏗️</span>
                </div>
                <h1 className="title">{t('default.title')}</h1>
                <p className="message">{t('default.message')}</p>
                <p className="sub-message">{t('default.subMessage')}</p>
                <div className="decoration">❤️</div>
                <button
                    className="back-home-button"
                    onClick={handleBackToHome}
                >
                    {t('default.backToHome')}
                </button>
            </div>
        </div>
    );
};

export default Default;